import { render, staticRenderFns } from "./jiatingzhuzhi.vue?vue&type=template&id=9c51d55a&"
import script from "./jiatingzhuzhi.vue?vue&type=script&lang=ts&"
export * from "./jiatingzhuzhi.vue?vue&type=script&lang=ts&"
import style0 from "./jiatingzhuzhi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports